// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import Glide from '@glidejs/glide';
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueEasyLightbox from 'vue-easy-lightbox';
import { BootstrapIcon } from '../../../dsl/front';
import { prepareImage } from '../../_filters';
import { ImageWithCaption } from '../ImageWithCaption';
import { ref } from '@vue/composition-api';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let Gallery = class Gallery extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the arrows (control buttons) are currently hidden.
         */
        this.arrowsHidden = false;
        /**
         * Glide instance.
         */
        this.glide = null;
        this.visibleRef = ref(false);
        this.indexRef = ref(0);
        this.showImg = (index) => {
            this.indexRef.value = index;
            this.visibleRef.value = true;
        };
    }
    /**
     * Prepares gallery images
     */
    get preparedGallery() {
        return [...this.images.map((image, index) => {
                return prepareImage(image, null, this.maxWidth, index > 0);
            })];
    }
    /**
     * Prepares gallery images
     */
    get preparedGalleryLightbox() {
        const nGallery = [];
        this.preparedGallery.map((image, index) => {
            const nImage = { ...image, ...{ thumb: { ...image } } };
            nImage.src = (image.fullscreen) ? image.fullscreen : image.src;
            nGallery.push(nImage);
        });
        return nGallery;
    }
    /**
     * Closes full screen view of image
     */
    closeFullScreenPreview() {
        this.visibleRef.value = false;
    }
    /**
     * Handles the `@click` event on the root component's HTML element.
     */
    onClick() {
        if (this.arrowsHidden) {
            this.showArrows();
        }
    }
    /**
     * Hides the arrows (control buttons).
     */
    hideArrows() {
        this.arrowsHidden = true;
    }
    /**
     * Initialises the Glide.
     */
    initGlide() {
        this.glide = new Glide(`#${this.$id()}`);
        this.glide.on('build.after', () => {
            if (this.windowService.isPhone) {
                this.hideArrows();
            }
        });
        this.glide.mount();
    }
    /**
     * Shows the arrows (control buttons).
     */
    showArrows() {
        this.arrowsHidden = false;
    }
};
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], Gallery.prototype, "fullScreen", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], Gallery.prototype, "imageClasses", void 0);
__decorate([
    Prop({
        type: Number,
        required: false,
        default: 800
    })
], Gallery.prototype, "maxWidth", void 0);
__decorate([
    Prop({
        type: Array,
        required: true
    })
], Gallery.prototype, "images", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], Gallery.prototype, "windowService", void 0);
Gallery = __decorate([
    Component({
        name: 'Gallery',
        components: {
            BootstrapIcon,
            ImageWithCaption,
            VueEasyLightbox
        },
        filters: { prepareImage },
        mounted() {
            if (this.images && this.images.length) {
                this.initGlide();
            }
            else {
                const unwatch = this.$watch('images', () => {
                    this.initGlide();
                    unwatch();
                });
            }
        },
        template: `
    <div v-if="(images && images.length)" class="gallery glide" :id="$id()" @click.once="onClick">
    <!-- Slides -->
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides list-unstyled">
        <li v-for="(image, index) in preparedGalleryLightbox" :key="index" class="glide__slide">
          <ImageWithCaption :image="image.thumb" :class="imageClasses" @click="()=>showImg(index)"/>
        </li>
      </ul>
    </div>
    <!-- END | Slides -->

    <VueEasyLightbox
      v-if="fullScreen"
      :index="indexRef.value"
      :visible="visibleRef.value"
      :imgs="preparedGalleryLightbox"
      @hide="closeFullScreenPreview"
    />

    <!-- Controls -->
    <div class="glide__arrows" :class="{ '--hidden': arrowsHidden }" data-glide-el="controls">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <BootstrapIcon name="arrow"/>
        <span class="visually-hidden">Poprzedni slajd</span>
      </button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        <BootstrapIcon name="arrow"/>
        <span class="visually-hidden">Następny slajd</span>
      </button>
    </div>
    <!-- END | Controls -->
    </div>
  `
    })
], Gallery);
export { Gallery };
